import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { VerifyAppTokenAction } from "../action/AuthAction";
import store, { persistor } from "../store";

const verifyRequests = new Map();

const parseAuthParams = () => {
	const hash = window.location.hash.replace(/^#/, "");
	const hashParams = new URLSearchParams(hash);
	const queryParams = new URLSearchParams(window.location.search);

	return {
		token:
			hashParams.get("mobile_view") ||
			queryParams.get("mobile_view") ||
			hashParams.get("token") ||
			queryParams.get("token"),
		redirect: hashParams.get("redirect") || queryParams.get("redirect"),
	};
};

const getSafeRedirectPath = (redirect) => {
	if (!redirect) {
		return "/";
	}

	try {
		const decoded = decodeURIComponent(redirect);
		if (decoded.startsWith("/") && !decoded.startsWith("//")) {
			return decoded;
		}
	} catch (error) {
		return "/";
	}

	return "/";
};

const verifyTokenOnce = (dispatch, token) => {
	if (!verifyRequests.has(token)) {
		verifyRequests.set(
			token,
			dispatch(VerifyAppTokenAction(token)).finally(() => {
				verifyRequests.delete(token);
			})
		);
	}

	return verifyRequests.get(token);
};

export default function AppAuth() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const started = useRef(false);

	useEffect(() => {
		console.log("[AppAuth] route u ekzekutua", window.location.href);

		if (started.current) {
			return;
		}

		started.current = true;

		const { token, redirect } = parseAuthParams();
		const redirectPath = getSafeRedirectPath(redirect);

		const finish = () => {
			navigate(redirectPath, { replace: true });
		};

		if (!token) {
			console.warn("[AppAuth] token mungon ne hash/query");
			finish();
			return;
		}

		const verify = async () => {
			try {
				const authData = await verifyTokenOnce(dispatch, token);
				console.log("[AppAuth] authData:", authData);

				await persistor.flush();

				const users = store.getState()?.productData?.users;
				console.log("[AppAuth] redux users pas login:", users);

				try {
					const persisted = JSON.parse(localStorage.getItem("persist:root") || "{}");
					const productData = JSON.parse(persisted.productData || "{}");
					console.log("[AppAuth] persist users:", productData.users);
				} catch (persistError) {
					console.warn("[AppAuth] nuk lexohet persist:root", persistError);
				}
			} catch (error) {
				console.error(
					"[AppAuth] verify-app-token deshtoi",
					error?.response?.data || error?.message || error
				);
			} finally {
				finish();
			}
		};

		verify();
	}, [dispatch, navigate]);

	return (
		<div className="min-h-screen flex items-center justify-center bg-white">
			<div className="flex flex-col items-center gap-4">
				<div
					className="h-12 w-12 border-4 border-gray-300 border-t-black rounded-full animate-spin"
					role="status"
					aria-label="Duke u autentikuar"
				/>
				<p className="text-sm text-gray-600">Duke u autentikuar...</p>
			</div>
		</div>
	);
}
